import { Routes, Route, Navigate } from 'react-router-dom'
import { useEffect } from 'react'
import { useAuthStore } from './store/authStore'
import { useTelegramBackButton } from './hooks/useTelegramBackButton'
import { useI18nSync } from './hooks/useI18nSync'
import TaskListPage from './pages/TaskListPage'
import TaskDetailPage from './pages/TaskDetailPage'
import SubmissionPage from './pages/SubmissionPage'
import ProfilePage from './pages/ProfilePage'
import LoginPage from './pages/LoginPage'
import FreeSubmissionPage from './pages/FreeSubmissionPage'
import ProtectedRoute from './components/common/ProtectedRoute'
import AdminLayout from './pages/admin/AdminLayout'
import AdminTasksPage from './pages/admin/AdminTasksPage'
import AdminCreateTaskPage from './pages/admin/AdminCreateTaskPage'
import AdminTaskDetailPage from './pages/admin/AdminTaskDetailPage'
import AdminSubmissionsPage from './pages/admin/AdminSubmissionsPage'
import AdminProductsPage from './pages/admin/AdminProductsPage'
import AdminProductDetailPage from './pages/admin/AdminProductDetailPage'
import AdminShopsPage from './pages/admin/AdminShopsPage'
import AdminShopDetailPage from './pages/admin/AdminShopDetailPage'
import AdminWorkersPage from './pages/admin/AdminWorkersPage'
import AdminWorkerDetailPage from './pages/admin/AdminWorkerDetailPage'
import AdminAnalyticsPage from './pages/admin/AdminAnalyticsPage'
import AdminBotsPage from './pages/admin/AdminBotsPage'
import AdminInviteCodesPage from './pages/admin/AdminInviteCodesPage'
import AdminUsersPage from './pages/admin/AdminUsersPage'
import AdminUserDetailPage from './pages/admin/AdminUserDetailPage'
import TaskItemDetailPage from './pages/TaskItemDetailPage'
import CreateShopPage from './pages/CreateShopPage'
import ShopDetailPage from './pages/ShopDetailPage'
import ShopsListPage from './pages/ShopsListPage'
import MySubmissionsPage from './pages/MySubmissionsPage'

export default function App() {
  const { initAuth } = useAuthStore()

  useEffect(() => {
    initAuth()
  }, [initAuth])

  useTelegramBackButton()
  useI18nSync()

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      {/* Worker routes — require Telegram auth */}
      <Route element={<ProtectedRoute />}>
        <Route path="/" element={<TaskListPage />} />
        <Route path="/tasks/:taskId" element={<TaskDetailPage />} />
        <Route path="/tasks/:taskId/items/:itemId" element={<TaskItemDetailPage />} />
        <Route path="/assignments/:assignmentId/submit/:itemId" element={<SubmissionPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/free-submit" element={<FreeSubmissionPage />} />
        <Route path="/shops" element={<ShopsListPage />} />
        <Route path="/shops/new" element={<CreateShopPage />} />
        <Route path="/shops/:merchantId" element={<ShopDetailPage />} />
        <Route path="/submissions" element={<MySubmissionsPage />} />
      </Route>

      {/* Admin panel — no Telegram auth, just API key */}
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Navigate to="/admin/shops" replace />} />
        <Route path="shops" element={<AdminShopsPage />} />
        <Route path="shops/:merchantId" element={<AdminShopDetailPage />} />
        <Route path="users" element={<AdminUsersPage />} />
        <Route path="users/:userId" element={<AdminUserDetailPage />} />
        <Route path="analytics" element={<AdminAnalyticsPage />} />
        <Route path="bots" element={<AdminBotsPage />} />
        {/* Deprecated crowd pages — routes resolvable, unlinked from nav */}
        <Route path="tasks" element={<AdminTasksPage />} />
        <Route path="tasks/new" element={<AdminCreateTaskPage />} />
        <Route path="tasks/:taskId" element={<AdminTaskDetailPage />} />
        <Route path="tasks/:taskId/edit" element={<AdminCreateTaskPage />} />
        <Route path="submissions" element={<AdminSubmissionsPage />} />
        <Route path="products" element={<AdminProductsPage />} />
        <Route path="products/:productId" element={<AdminProductDetailPage />} />
        <Route path="workers" element={<AdminWorkersPage />} />
        <Route path="workers/:workerId" element={<AdminWorkerDetailPage />} />
        <Route path="invite-codes" element={<AdminInviteCodesPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
